/**
 * Created by Carsten Bühler
 * User: CBuehler on 15.02.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from "prop-types";

const TimeLineItemMessageHeader = props => <div className="m-b-xs">{props.children}</div>;

TimeLineItemMessageHeader.propTypes = {
    children: PropTypes.node
};

export default TimeLineItemMessageHeader;



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/TimeLineItemMessageHeader.jsx